import { booleanAttribute, Component, computed, HostBinding, input, InputSignal, Signal } from '@angular/core';

import { _BaseControlComponent } from './_base-control.component';
import { fieldAppearance, fieldColor, floatLabel, hintAlign, subscriptSizing, TFieldAppearance, TFieldColor, TFloatLabel, THintAlign, TSubscriptSizing } from '../models/form-field-options';
import { formFieldSize, TFormFieldSize } from '../models/form-field-size';

// Gedeelde basis voor controls in een form-field (Input, Textarea, Select, Date): de
// form-field-inputs staan hier één keer, met eigen types i.p.v. Material-types.
@Component({
    selector: 'app-mat-form-field',
    template: '',
    styleUrls: [],
})
export abstract class _MatFormFieldComponent
    extends _BaseControlComponent
{
    abstract appearance$$: InputSignal<TFieldAppearance>;
    abstract classHeight$$: InputSignal<TFormFieldSize>;
    abstract color$$: InputSignal<TFieldColor>;
    abstract floatLabel$$: InputSignal<TFloatLabel>;
    abstract hideLineRipple$$: InputSignal<boolean>;
    abstract hideRequiredMarker$$: Signal<boolean>;
    abstract hint$$: InputSignal<string>;
    abstract hintAlign$$: InputSignal<THintAlign>;
    abstract hintLabel$$: InputSignal<string>;
    abstract label$$: InputSignal<string>;
    abstract required$$: Signal<boolean>;
    abstract subscriptSizing$$: InputSignal<TSubscriptSizing>;

    protected _input_appearance$$         = input<TFieldAppearance>(fieldAppearance.fill,   { alias: 'appearance' });
    protected _input_classHeight$$        = input<TFormFieldSize>(formFieldSize.defHeight,  { alias: 'classHeight' });
    protected _input_color$$              = input<TFieldColor>(fieldColor.primary,          { alias: 'color' });
    protected _input_floatLabel$$         = input<TFloatLabel>(floatLabel.auto,             { alias: 'floatLabel' });
    protected _input_hideLineRipple$$     = input<boolean>(false,                           { alias: 'hideLineRipple' });
    protected _input_hideRequiredMarker$$ = input<boolean | null | undefined>(null,         { alias: 'hideRequiredMarker' });
    protected _input_hint$$               = input<string>('',                               { alias: 'hint' });
    protected _input_hintAlign$$          = input<THintAlign>(hintAlign.start,              { alias: 'hintAlign' });
    protected _input_hintLabel$$          = input<string>('',                               { alias: 'hintLabel' });
    protected _input_label$$              = input<string>('',                               { alias: 'label' });
    protected _input_required$$           = input(false,                                    { transform: booleanAttribute, alias: 'required' });
    protected _input_subscriptSizing$$    = input<TSubscriptSizing>(subscriptSizing.dynamic, { alias: 'subscriptSizing' });

    // Zonder expliciete waarde: marker alleen tonen bij een verplicht veld.
    protected _hideRequiredMarker$$ = computed(() =>
        this._input_hideRequiredMarker$$() ?? !this.required$$()
    );

    @HostBinding('class.hide-line-ripple') get ClassHideLineRipple() { return this._input_hideLineRipple$$(); }

    override get label() { return this._input_label$$(); }
}
